export const PRE_PAYMENT_PRICE_LEVELS = [
    { label: '全国团队', salesman: 'salesmanCountryPrice', owner: 'ownerCountryPrice' },
    { label: '大区团队', salesman: 'salesmanRegionPrice', owner: 'ownerRegionPrice' },
    { label: '省级团队', salesman: 'salesmanProvincePrice', owner: 'ownerProvincePrice' },
    { label: '市级团队', salesman: 'salesmanCityPrice', owner: 'ownerCityPrice' },
    { label: '区县团队', salesman: 'salesmanDistrictPrice', owner: 'ownerDistrictPrice' }
];

export const PRE_PAYMENT_PRICE_FIELDS = PRE_PAYMENT_PRICE_LEVELS.flatMap((level) => [level.salesman, level.owner]);

export function createEmptyPrePaymentPrices() {
    return PRE_PAYMENT_PRICE_FIELDS.reduce((result, field) => {
        result[field] = undefined;
        return result;
    }, {});
}

export function pickPrePaymentPrices(source = {}) {
    return PRE_PAYMENT_PRICE_FIELDS.reduce((result, field) => {
        result[field] = source[field] != null ? Number(source[field]) : undefined;
        return result;
    }, {});
}

export function formatPrePaymentPriceRange(item) {
    const prices = PRE_PAYMENT_PRICE_FIELDS
        .map((field) => Number(item?.[field]))
        .filter((value) => !Number.isNaN(value) && value > 0);
    if (!prices.length) {
        return '';
    }
    const min = Math.min(...prices);
    const max = Math.max(...prices);
    if (min === max) {
        return min.toFixed(2);
    }
    return `${min.toFixed(2)}~${max.toFixed(2)}`;
}

export function hasCompletePrePaymentPrices(item) {
    return PRE_PAYMENT_PRICE_FIELDS.every((field) => {
        const value = Number(item?.[field]);
        return !Number.isNaN(value) && value > 0;
    });
}
